
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"45","height":"31","rx":"5.5","fill":"#fff","stroke":"#EEE"}}),_c('path',{attrs:{"d":"M8.452 18.672c-.608 0-1.078-.15-1.41-.45-.328-.304-.492-.758-.492-1.362v-2.55h1.23v2.496c0 .304.046.53.138.678.096.148.274.222.534.222.256 0 .432-.072.528-.216.096-.144.144-.378.144-.702V14.31h1.242v2.532c0 .312-.044.584-.132.816a1.446 1.446 0 01-.378.564c-.168.152-.37.266-.606.342a2.732 2.732 0 01-.798.108zm2.71-4.362h1.386l1.374 2.418V14.31h1.074v4.29h-1.188l-1.566-2.694V18.6h-1.08v-4.29zm4.664 0h1.236v1.698l1.29-1.698h1.284l-1.572 1.992L19.72 18.6h-1.422l-1.236-1.794V18.6h-1.236v-4.29zm4.354 0h1.386l1.373 2.418V14.31h1.075v4.29h-1.188l-1.567-2.694V18.6h-1.08v-4.29zm6.71 3.396c.304 0 .544-.108.72-.324.176-.22.264-.524.264-.912v-.048c0-.384-.09-.682-.27-.894-.176-.212-.416-.318-.72-.318s-.544.106-.72.318c-.176.208-.264.508-.264.9v.048c0 .392.09.696.27.912.18.212.42.318.72.318zm-.024.966c-.348 0-.66-.054-.936-.162a2.082 2.082 0 01-.708-.45 1.93 1.93 0 01-.45-.69 2.435 2.435 0 01-.156-.888v-.048c0-.328.058-.626.174-.894a2.058 2.058 0 011.2-1.134c.276-.104.574-.156.894-.156.328 0 .63.05.906.15.28.1.522.242.726.426.2.188.356.416.468.684a2.2 2.2 0 01.174.894v.048c0 .332-.054.634-.162.906a1.946 1.946 0 01-.462.696c-.2.196-.442.348-.726.456a2.6 2.6 0 01-.942.162zm2.411-4.362h1.242l.552 2.676.576-2.676h1.092l.624 2.7.582-2.7h1.14l-1.002 4.29H32.8l-.66-2.724-.666 2.724h-1.2l-.996-4.29zm6.307 0h1.386l1.374 2.418V14.31h1.074v4.29H38.23l-1.566-2.694V18.6h-1.08v-4.29z","fill":"#BBB"}})])
          )
        }
      }
    